export default __webpack_public_path__ + "static/flammable_w.d72629dd3e1535d2532e269e819101a5.svg";